import { Stack } from "@altimateai/lego";
import { Tooltip } from "@altimateai/lego";
import dayjs from "dayjs";
import { InfoRow } from "./InfoRow";
import { IconInfoCircle } from "@tabler/icons-react";
import { BaseDetailsProps } from "../types";
import { useInsightState } from "../context";
import { useAppState } from "@/modules/app/useAppContext";
import { MoneySavingsTag } from "../tags";

const MoneySavingsInfo = ({
  opportunity,
  savingsInfo,
}: Pick<BaseDetailsProps, "opportunity" | "savingsInfo">) => {
  const { endDate, startDate } = useInsightState();
  const { currencySymbol } = useAppState();

  return (
    <InfoRow
      label="Money Savings"
      value={
        <Stack direction="row" align="center" gap="xs">
          <MoneySavingsTag savings={opportunity.money_savings} />

          {String(opportunity?.status) === "2" &&
            savingsInfo?.start_date &&
            savingsInfo?.end_date &&
            savingsInfo?.altimate_estimated_cost_saving && (
              <Tooltip
                title={
                  <div>
                    <div>Start Date: {dayjs(savingsInfo?.start_date).format("DD/MM/YYYY")}</div>
                    <div>End Date: {dayjs(savingsInfo?.end_date).format("DD/MM/YYYY")}</div>
                    <div>
                      Estimated Savings: {currencySymbol}
                      {savingsInfo?.altimate_estimated_cost_saving} per day
                    </div>
                  </div>
                }
              >
                <IconInfoCircle className="al-w-4 al-h-4" />
              </Tooltip>
            )}
        </Stack>
      }
      tooltip={`Approximate money saved after implementing the opportunity between ${dayjs(startDate).format("MMM D, YYYY")} - ${dayjs(endDate).format("MMM D, YYYY")}.`}
    />
  );
};

export default MoneySavingsInfo;
